import { render, staticRenderFns } from "./ModifiedServiceName.vue?vue&type=template&id=7319c942&"
import script from "./ModifiedServiceName.vue?vue&type=script&lang=js&"
export * from "./ModifiedServiceName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7319c942')) {
      api.createRecord('7319c942', component.options)
    } else {
      api.reload('7319c942', component.options)
    }
    module.hot.accept("./ModifiedServiceName.vue?vue&type=template&id=7319c942&", function () {
      api.rerender('7319c942', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25AQakYKHaSyn/JS/comp/ModifiedServiceName.vue"
export default component.exports